import React, { useState, useEffect } from "react";
import {
  Card,
  CardBody,
  CardTitle,
  Container,
  Row,
  Col,
  Progress,
  CardImg,
  Button,
  UncontrolledTooltip,
} from "reactstrap";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import CircleChart from "dashboard/hr-management/variables/circlebar";
import { api } from "../../../api";
import Cookies from 'js-cookie';
import { useNavigate } from 'react-router-dom';

// Add this style block at the top of the component
const goodMessageStyle = `
.good-message {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #d86f89;
  color: #222;
  font-weight: bold;
  font-size: 1.2rem;
  border-radius: 10px;
  padding: 0.5em 1.5em;
  margin: 0 auto;
  white-space: nowrap;
  max-width: 100vw;
  box-shadow: 0 2px 8px rgba(0,0,0,0.05);
}
`;

const calendarCustomStyle = `
.react-calendar__tile--active,
.react-calendar__tile--range,
.react-calendar__tile--rangeStart,
.react-calendar__tile--rangeEnd {
  background: #d86f89 !important;
  color: #fff !important;
}
`;

const getImagePath = (imageName) => {
  const isProduction = window.location.hostname !== 'localhost' && window.location.hostname !== '127.0.0.1';
  const defaultImage = isProduction ? '/images/default-profile.png' : '/dashboard/images/default-profile.png';
  
  if (!imageName) return defaultImage;
  
  try {
    return isProduction ? `/images/${imageName}` : `/dashboard/images/${imageName}`;
  } catch (error) {
    console.error('Error loading image:', error);
    return defaultImage;
  }
};

const Dashboard3 = () => {
  const [date, setDate] = useState(new Date());
  const [selectedDateLabel, setSelectedDateLabel] = useState("");
  const [isBirthday, setIsBirthday] = useState(false);
  const [timeOfDay, setTimeOfDay] = useState("");
  const navigate = useNavigate();

  // Function to format the selected date label
  const getFormattedDateLabel = (date) => {
    // Customize the date label format as needed
    return `${date.toLocaleString("default", {
      month: "long",
    })} ${date.getDate()}, ${date.getFullYear()}`;
  };
  useEffect(() => {
    // Update the selected date label when the date changes
    setSelectedDateLabel(getFormattedDateLabel(date));
  }, [date]);

  const checkBirthday = (date) => {
    // Check if the selected date matches a predefined birthday (e.g., January 1)
    return date.getMonth() === 0 && date.getDate() === 1;
  };

  const getTimeOfDay = (date) => {
    const hour = date.getHours();

    if (hour >= 0 && hour < 12) {
      return "Morning🌞";
    } else if (hour >= 12 && hour < 18) {
      return "Afternoon⛅"; // Corrected to 'Afternoon'
    } else {
      return "Night🌙";
    }
  };

  useEffect(() => {
    const label = getFormattedDateLabel(date);
    setSelectedDateLabel(label);
    setIsBirthday(checkBirthday(date));
    setTimeOfDay(getTimeOfDay(date));
  }, [date]);

  const [progressPercentage, setProgressPercentage] = useState(75);

  const [employees, setEmployees] = useState([]);
  const fetchEmployeeName = async () => {
    try {
      const company_id = Cookies.get('company_id');
      if (!company_id) {
        throw new Error('Missing company_id in cookies');
      }
      const response = await api.get(`employeeCalendar.php?company_id=${company_id}`);
      setEmployees(response.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchEmployeeName();
  }, []);

  useEffect(() => {
    const label = getFormattedDateLabel(date);
    setSelectedDateLabel(label);

    // Check if it's the user's birthday
    // const isAnyBirthday = employees.some(employee => isEmployeeBirthday(date, employee))
    // setIsBirthday(checkBirthday(date));

    // Determine the time of day
    setTimeOfDay(getTimeOfDay(date));
  }, [date, employees]);

  const isEmployeeBirthday = (date, employee) => {
    const employeeDOB = new Date(employee.dob);
    return (
      date.getDate() === employeeDOB.getDate() &&
      date.getMonth() === employeeDOB.getMonth()
    );
  };

  const isEmployeeWorkAnniversary = (date, employee) => {
    const anniversaryDate = new Date(employee.doj);
    return (
      date.getDate() === anniversaryDate.getDate() &&
      date.getMonth() === anniversaryDate.getMonth()
    );
  };

  const [count, setCount] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const company_id = Cookies.get('company_id');
        const emp_id = Cookies.get('emp_id');
        if (!company_id || !emp_id) {
          throw new Error('Missing company_id or emp_id in cookies');
        }
        const response = await api.get(`hrdashboard.php?company_id=${company_id}&emp_id=${emp_id}`);
        setCount(response.data);
        // console.log(response.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  return (
    <>
      <style>{goodMessageStyle}</style>
      <div className="header bg-gradient-info py-7 py-lg-8">
        <Container fluid>
          <Row>
            {/* Total Employees */}
            <Col lg="6" xl="3" className="mb-3">
              <Card
                className="card-stats mb-4 mb-xl-0"
                style={{
                  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.15)",
                  backgroundColor: "#fff",
                }}
              >
                <CardBody>
                  <div className="d-flex justify-content-between align-items-center">
                    <CardTitle className="h4 mb-0">Total Employees</CardTitle>
                    <span className="h2 font-weight-bold">
                      {count[0]?.empcount ?? "0"}
                    </span>
                  </div>
                </CardBody>
              </Card>
            </Col>

            {/* Ontime Today */}
            <Col lg="6" xl="3" className="mb-3">
              <Card
                className="card-stats mb-4 mb-xl-0"
                style={{
                  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.15)",
                  backgroundColor: "#fff",
                  cursor: 'pointer',
                }}
                onClick={() => navigate('/hr-admin/hr-management/attendance')}
              >
                <CardBody>
                  <div className="d-flex justify-content-between align-items-center">
                    <CardTitle className="h4 mb-0">Ontime Today</CardTitle>
                    <span className="h2 font-weight-bold">
                      {count[1]?.ontimecount ?? "0"}
                    </span>
                  </div>
                </CardBody>
              </Card>
            </Col>

            {/* Late Today */}
            <Col lg="6" xl="3" className="mb-3">
              <Card
                className="card-stats mb-4 mb-xl-0"
                style={{
                  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.15)",
                  backgroundColor: "#fff",
                  cursor: 'pointer',
                }}
                onClick={() => navigate('/hr-admin/hr-management/attendance')}
              >
                <CardBody>
                  <div className="d-flex justify-content-between align-items-center">
                    <CardTitle className="h4 mb-0">Late Today</CardTitle>
                    <span className="h2 font-weight-bold">
                      {count[2]?.latecount ?? "0"}
                    </span>
                  </div>
                </CardBody>
              </Card>
            </Col>

            {/* Leave Requests */}
            <Col lg="6" xl="3" className="mb-3">
              <Card
                className="card-stats mb-4 mb-xl-0"
                style={{
                  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.15)",
                  backgroundColor: "#fff",
                }}
              >
                <CardBody>
                  <div className="d-flex justify-content-between align-items-center">
                    <CardTitle className="h4 mb-0">Leave Requests</CardTitle>
                    <span className="h2 font-weight-bold">
                    {count[4]?.leavecount ?? "0"}
                    </span>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>

          <Row className="mt-5">
            <Col lg="8">
              <Card
                className="card-stats mb-4 mb-xl-0 m-0"
                style={{
                  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.15)",
                  backgroundColor: "#fff",
                  borderRadius: "15px",
                }}
              >
                <CardBody>
                  <Row>
                    <h1 className="px-2" style={{ fontWeight: "bolder" }}>
                      Employee's Attendance
                    </h1>
                  </Row>
                </CardBody>
              </Card>
              <Card
                className="card-stats mb-4 mb-xl-0 p-2 mt-3"
                style={{
                  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.15)",
                  backgroundColor: "#fff",
                  borderRadius: "15px",
                }}
              >
                <CardBody>
                  <CircleChart />
                </CardBody>
              </Card>
            </Col>
            <Col lg="4">
             <Card
                className="card-stats mb-4 mb-xl-0"
                style={{
                  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.15)",
                  backgroundColor: "#fff",
                  borderRadius: "15px",
                  padding: '1rem',
                  margin: 0,
                  width: '100%',
                  maxWidth: 420,
                  minWidth: 0,
                  alignSelf: 'center',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                }}
              >
                <CardBody style={{ padding: 0, width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                  <Row style={{ margin: 0, width: '100%', justifyContent: 'center' }}>
                    <div className="col" style={{ textAlign: 'center' }}>
                      <CardTitle
                        tag="h3"
                        className="text-uppercase text-muted mb-0"
                        style={{ marginBottom: '0.5rem' }}
                      >
                        Calendar
                      </CardTitle>
                    </div>
                  </Row>
                  <Row style={{ margin: 0, width: '100%', justifyContent: 'center' }}>
                    <Col className="col-auto mt-2" style={{ padding: 0, width: '100%', display: 'flex', justifyContent: 'center' }}>
                      <div style={{ width: '100%', maxWidth: 340, minWidth: 0, display: 'flex', justifyContent: 'center' }}>
                        <Calendar
                          style={{ width: '100%' }}
                          onChange={setDate}
                          value={date}
                        />
                      </div>
                    </Col>
                  </Row>
                  <Row className="mt-3">
                    <Col>
                      <p>Selected Date: {selectedDateLabel}</p>
                      {isBirthday && (
                        <div>
                          <Row>
                            <Col className="col-auto">
                              {/* Add the image on one side */}
                              <img
                                src="path/to/birthday_image.jpg"
                                alt="Birthday"
                                style={{
                                  width: "100px", // Set the width of the image
                                  height: "100px", // Set the height of the image
                                  borderRadius: "50%", // Make it a circular image
                                }}
                              />
                            </Col>
                          </Row>
                        </div>
                      )}
                      <style>{calendarCustomStyle}</style>
                      {timeOfDay && (
                        <div style={{ textAlign: "center", marginTop: 16 }}>
                          <div className="good-message">Good {timeOfDay}</div>
                        </div>
                      )}
                    </Col>
                  </Row>

                  {/* Birthday and Anniversary */}

                  {employees.some(
                    (employee) =>
                      isEmployeeBirthday(date, employee) ||
                      isEmployeeWorkAnniversary(date, employee)
                  ) && (
                    <>
                      {employees.map((employee, index) => {
                        if (
                          isEmployeeBirthday(date, employee) &&
                          isEmployeeWorkAnniversary(date, employee)
                        ) {
                          return (
                            <Row
                              key={index}
                              style={{
                                backgroundColor: "#dff6f9",
                                borderRadius: "0.375rem",
                                padding: "10px",
                                boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
                              }}
                            >
                              <Col xs={3} className="text-center">
                                <img
                                  src={employee.profile_image ? getImagePath(employee.profile_image) : getImagePath('default-profile.png')}
                                  alt="Birthday & Work Anniversary"
                                  style={{
                                    width: "80px",
                                    height: "80px",
                                    borderRadius: "50%",
                                    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
                                  }}
                                  onError={(e) => {
                                    e.target.onerror = null;
                                    e.target.src = getImagePath('default-profile.png');
                                  }}
                                />
                              </Col>
                              <Col>
                                <p
                                  style={{
                                    fontSize: "bold",
                                    color: "#333",
                                    marginBottom: "10px",
                                    textAlign: "center",
                                  }}
                                >
                                  🎉Happy Birthday & Work Anniversary!🎉
                                </p>
                                <p
                                  style={{
                                    fontWeight: "bold",
                                    textAlign: "center",
                                    fontSize: "18px",
                                    color: "#666",
                                    marginBottom: "5px",
                                  }}
                                >
                                  {employee.emp_name}
                                </p>
                                <p
                                  style={{
                                    marginTop: "10px",
                                    fontSize: "16px",
                                    color: "#555",
                                    textAlign: "center",
                                  }}
                                >
                                  Double celebration! Wishing you a day filled
                                  with joy, laughter, and all the things you
                                  love.
                                </p>
                              </Col>
                            </Row>
                          );
                        } else if (isEmployeeBirthday(date, employee)) {
                          return (
                            <Row
                              key={index}
                              style={{
                                border: "2px solid #ddd",
                                borderRadius: "10px",
                                padding: "20px",
                                backgroundColor: "#fff",
                                boxShadow: "0px 4px 8px rgba(0,0,0,0.1)",
                                marginBottom: "10px",
                              }}
                            >
                              <Col xs={3} className="text-center">
                                <img
                                  src={employee.profile_image ? getImagePath(employee.profile_image) : getImagePath('default-profile.png')}
                                  alt="Birthday"
                                  style={{
                                    width: "80px",
                                    height: "80px",
                                    borderRadius: "50%",
                                    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
                                  }}
                                  onError={(e) => {
                                    e.target.onerror = null;
                                    e.target.src = getImagePath('default-profile.png');
                                  }}
                                />
                              </Col>
                              <Col>
                                <p
                                  style={{
                                    fontSize: "bold",
                                    color: "#333",
                                    marginBottom: "10px",
                                    textAlign: "center",
                                  }}
                                >
                                  🎉Happy Birthday!🎉
                                </p>
                                <p
                                  style={{
                                    fontWeight: "bold",
                                    textAlign: "center",
                                    fontSize: "18px",
                                    color: "#666",
                                    marginBottom: "5px",
                                  }}
                                >
                                  {employee.emp_name}
                                </p>
                                <p
                                  style={{
                                    marginTop: "10px",
                                    fontSize: "16px",
                                    color: "#555",
                                    textAlign: "center",
                                  }}
                                >
                                  Wishing you a day filled with joy, laughter,
                                  and all the things you love!
                                </p>
                              </Col>
                            </Row>
                          );
                        } else if (isEmployeeWorkAnniversary(date, employee)) {
                          return (
                            <Row
                              key={index}
                              style={{
                                border: "2px solid #ddd",
                                borderRadius: "10px",
                                padding: "20px",
                                backgroundColor: "#fff",
                                boxShadow: "0px 4px 8px rgba(0,0,0,0.1)",
                                marginBottom: "10px",
                              }}
                            >
                              <Col xs={3} className="text-center">
                                <img
                                  // src={require(`./../../images/${employee.profile_image}`)}
                                  src={require("../../images/celebrate-emoji.gif")}
                                  alt="Work Anniversary"
                                  style={{
                                    width: "80px",
                                    height: "80px",
                                    borderRadius: "50%",
                                    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
                                  }}
                                />
                              </Col>
                              <Col>
                                <p
                                  style={{
                                    fontSize: "bold",
                                    color: "#333",
                                    marginBottom: "10px",
                                    textAlign: "center",
                                  }}
                                >
                                  🎉Congratulations on your work anniversary!🎉
                                </p>
                                <p
                                  style={{
                                    fontWeight: "bold",
                                    textAlign: "center",
                                    fontSize: "18px",
                                    color: "#666",
                                    marginBottom: "5px",
                                  }}
                                >
                                  {employee.emp_name}
                                </p>
                                <p
                                  style={{
                                    marginTop: "10px",
                                    fontSize: "16px",
                                    color: "#555",
                                    textAlign: "center",
                                  }}
                                >
                                  It's been a pleasure having you on the team.
                                  Your hard work and dedication are appreciated.
                                </p>
                              </Col>
                            </Row>
                          );
                        } else {
                          return null;
                        }
                      })}
                    </>
                  )}

                  {/* ... Your existing code ... */}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default Dashboard3;
